<template>
  <ElDatePicker class="mi-date-picker" v-bind="$props" v-model="value">
    <template v-if="$slots.default" #default>
      <slot name="default" />
    </template>

    <template v-if="$slots['range-separator']" #range-separator>
      <slot name="range-separator" />
    </template>
  </ElDatePicker>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { ElDatePicker, TimePickerDefaultProps, DatePickType, ModelValueType } from 'element-plus';

type Props = {
  type?: DatePickType;
} & Partial<TimePickerDefaultProps>;

const props = withDefaults(defineProps<Props>(), {
  type: 'date',
  teleported: true,
  validateEvent: true,
  editable: true,
  clearable: true,
});
const emit = defineEmits<{
  'update:modelValue': [e: ModelValueType | undefined];
}>();

const value = computed({
  get() {
    return props.modelValue;
  },
  set(val: ModelValueType | undefined) {
    emit('update:modelValue', val);
  },
});
</script>

<style lang="scss" src="./index.scss" />
